import { UserRole } from '@/types';
import { getOrgAdminLanding, needsOrgSetup, ORG_PRODUCTS_PATH } from '@/utils/orgConsole';

/** Role-aware landing route — keeps stakeholders off delivery-only pages. */
export function getHomeRouteForRole(
  role?: string | null,
  settings?: Record<string, unknown> | null,
): string {
  switch (role) {
    case UserRole.STAKEHOLDER:
      return '/stakeholder';
    case UserRole.SUPER_ADMIN:
      return '/admin';
    case UserRole.ADMIN:
      return getOrgAdminLanding(settings);
    case UserRole.GUEST:
      return '/dashboard';
    case UserRole.MANAGER:
    case UserRole.MEMBER:
      return '/dashboard';
    default:
      return '/dashboard';
  }
}

export { needsOrgSetup, ORG_PRODUCTS_PATH };
